export default {"src":"/_next/static/media/earn.b0eb0389.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};